<template>
    <el-dialog  title="查看问答内容" :visible.sync="showBlock" :destroy-on-close="true" width="600px" :before-close="handleClose">
        <div class="warp-form">			
         	    <div class="deail">
	         	  <div class="common-items-center" v-for="(item,index) in message" :key="index">
	         	    <span style="margin: 10px;">{{ item.unit }}</span>
	         	    <span>{{ datas[item.key] }}</span>
	         	  </div>				
	            </div>			
            
                <div class="warp-btn">
                    <el-form-item
                        <div  class="dialog-footer">
                            <el-button @click="handleClose">取消</el-button>                            
                        </div>
                    </el-form-item>
                </div> 
        </div>
    </el-dialog>
</template>
<script>
  import {url,operate} from '@/utils/config'
  import {postFun,putFun} from '@/utils/httpFun'
  export default{

     data(){
       return{
            showBlock: false,
			datas:{},
		
			showBlock:false,
			message:[
			  {
			    key:'problem',
			    unit:'具体问题:',
				},
			  {
			    key:'answer',
			    unit:'回答内容:',
			  },
			  {
			    key:'operator',
			    unit:'提问人员:',
			  },
			  {
			    key:'createTime',
			    unit:'创建时间:',
			  },
			  {
			    key:'publishPlatform',
			    unit:'平台来源:',
			  }
			]
       }
     }, 
     created(){
       
     },
     methods:{

        //重置输入框信息
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        //提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.dealMess()
                } else {
                  console.log('error submit!!');
                  return false;
                }
            });
        },

        //开启弹窗
        showMessage(ev,val){
			this.datas=val
			switch(val.publishPlatform*1){
				case 1:
				this.datas.publishPlatform="运营"				
				break
				case 2:
				this.datas.publishPlatform="工厂"
				break
				case 3:
				this.datas.publishPlatform="代理商"
				break
				case 4:
				this.datas.publishPlatform="工程商"
				break
				default:
				break
			}
            this.showBlock = true                                
        },
       
        //关闭弹窗
        handleClose() {
            this.showBlock = false
           
        }
     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }
   .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   .warp-form{
      ::v-deep .el-input__count{
         background-color: rgba(0, 0, 0, 0);
      }
   }
   
</style>